module.exports = __webpack_public_path__ + "img/instagram.d9b93f22.webp";